import { Controller } from '@hotwired/stimulus'

import { dispatcher } from '../pub_controller'
import { DispatchEvent } from '../../types/'
import { Confirmable } from '../../models/'

export class ConfirmableNavigationController extends Controller {
  static values = {
    pubChannel: String,
    pubAs: String,
    confirmationTitle: String,
    confirmationMessage: String,
    href: String,
  }

  declare readonly hrefValue: string
  declare readonly pubChannelValue: string
  declare readonly pubAsValue: string
  declare readonly confirmationMessageValue: string
  declare readonly confirmationTitleValue: string

  confirm() {
    if (!this.hrefValue) {
      throw (new Error(), "can't navigate without an href")
    }

    if (!this.pubChannelValue) {
      throw (new Error(), "can't navigate without an pub channel")
    }

    const confirmable = new Confirmable({
      pubChannel: this.pubChannelValue,
      pubAs: this.pubAsValue || 'navigate',
      detail: this.hrefValue,
      confirmationTitle: this.confirmationTitleValue,
      confirmationMessage: this.confirmationMessageValue,
    })

    dispatcher(this, 'confirm-operation', this.pubChannelValue, confirmable)
  }

  navigate({ detail: { value: href } }: DispatchEvent<string>) {
    window.location.assign(href)
  }
}
